import { Loading } from "@/components/common/Loading";
import { ScheduleService } from "@/service/services/Schedule.service";
import { Typography } from "@mui/material";
import { useState } from "react";
import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalFooter } from "../ModalFooter";
import { ModalHeader } from "../ModalHeader";
import { Props } from "./ModalScheduleCompanyDelete.type";

export const ModalScheduleCompanyDelete: React.FC<Props> = (props:any): JSX.Element => {
    const { open, closeModal, schedule, onList, clearState } = props;
    const [loading, setLoading] = useState<boolean>(false);

    const onDeleted= async()=>{
        setLoading(true);
        await ScheduleService.deleteScheduleCompany(schedule.id).then((data) => {
            onList && onList();
            closeModal && closeModal();
        })
        setLoading(false);
    }
  
  return (
    <>
    {loading && <Loading/>}
    <Modal
      open={open}
      handleClose={closeModal}
      size="xs"
    >
      <ModalHeader
        text="ELIMINAR HORARIO"
        className='positionElements'
        onCancel={closeModal}
        clearState={clearState}
      >
      </ModalHeader>

      <ModalBody>
        <Typography variant="subtitle1" className="textColor"> 
          ¿Está seguro de eliminar este horario?
        </Typography>
      </ModalBody>

      <ModalFooter 
        confirmText="Eliminar"
        cancelText="CANCELAR"
        onCancel={closeModal}
        className="footerRight"
        onConfirm={onDeleted}
        clearState={clearState}
      />
    </Modal>
    </>
  )
}